import { actionTypes } from './actionType';

export const setError = (payload: String | null) => {
    return (dispatch: any) => {
        dispatch({
            type: actionTypes.SET_ERROR,
            payload
        });
    };
};

export const clearError = () => {
    return (dispatch: any) => {
        dispatch({
            type: actionTypes.CLEAR_ERROR
        });
    };
};
